import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServicesService } from '@api/services.service';
import { servicePaymentModel } from '@shared/model/service-payment.model';
import { Subject, takeUntil } from 'rxjs';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
  { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
  { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
  { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
  { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
  { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
  { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
  { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
  { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
  { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
];

@Component({
  selector: 'app-services-payment',
  templateUrl: './services-payment.component.html',
  styleUrls: ['./services-payment.component.scss']
})
export class ServicesPaymentComponent implements OnInit {
  servicePayment: servicePaymentModel[];
  serviceInstallment;
  public destroy$ = new Subject<void>();
  trackingId: number;
  paymentService;
  displayedColumns1: string[] = ['servicePaymentType', 'currency', 'totalAmount', 'totalPaid', 'toBePaid'];
  displayedColumns2: string[] =
    ['installmentStatusTypeId','installmentPercent', 'currencyUnit',
      'paidCurrencyTypeId', 'paidValue', 'stateId',
      'targetCurrencyTypeId', 'targetValue', 'paidAt','installmentTypeId'
    ];

  dataSource = ELEMENT_DATA;

  constructor(
    private servicesService: ServicesService,
    private activeRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.getTrackingId();
    this.getPayment();
  }

  getTrackingId() {
    this.trackingId = this.activeRoute.snapshot.params['tracking-id'];
  }
  getPayment() {
    this.servicesService.getPaymentService(this.trackingId).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.paymentService = res;
        this.servicePayment = this.paymentService?.servicePayment;
        this.serviceInstallment = this.paymentService?.serviceInstallment;
        console.log(  this.serviceInstallment);
        
      }
    )
  }
}
